import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { customBannersBackend } from './custom-banners.backend';
import { customBannersReducer } from './custom-banners.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('customBanners', customBannersReducer),
    BackendModule.forFeature('customBanners', customBannersBackend),
  ],
})
export class DatastoreCustomBannersModule {}
